/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export { default, Icon } from '../components/icon-new';
/**
 * @deprecated Import from the generated per-export subpath instead.
 */
export type { NewIconProps, NewCoreIconProps } from '../types';
